import { Injectable } from '@angular/core';
import { TAnyFunction } from '@core/helpers';

@Injectable({
  providedIn: 'root',
})
export class ScrollHandlingService {
  handleScrollChange(scrollElement: HTMLElement, bufferSize: number, callback: TAnyFunction): void {
    const remainingScroll =
      scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight;

    if (remainingScroll < bufferSize) {
      callback();
    }
  }
}
